import Button from '../../../components/CustomButtons/ButtonTS';
import EditAttributesOutlined from '@material-ui/icons/EditOutlined';
import Tooltip from "@material-ui/core/Tooltip";
import React from 'react';
import { INode } from '../../helpers/interfaces';

interface IEditIconProps {
	show: boolean;
	node: INode;
	showEditNodeNameCard(node: INode): void;
}

export const EditIcon = (props: IEditIconProps) => {
	const { show, showEditNodeNameCard, node } = props;
	if (!show) {
		return null;
	}
	return (
	  //extra div is necessary for tooltip to work - child of a Material-UI Tooltip must be able to hold a ref.
	    <Tooltip title="Edit name">
	        <div>
                <Button
                    color={'info'}
                    simple
                    justIcon
                    onClick={() => showEditNodeNameCard(node)}
                    data-testid='editIcon'
                >
                    <EditAttributesOutlined />
                </Button>
            </div>
		</Tooltip>
	);
};

export default EditIcon;
